import { CalendarComponent } from "./calendar/calendar.component";
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { ColorComponent } from "./color/color.component";
import { ConvertibleSeatsInputComponent } from "./convertible-seats-input/convertible-seats-input.component";
import { InputComponent } from "./input.component";
import { InputPasswordComponent } from "./input-password/input-password.component";
import { InputSearchComponent } from "./input-search/input-search.component";
import { MultiselectCheckboxesComponent } from "./multiselect-checkboxes/multiselect-checkboxes.component";
import { MultiSelectComponent } from "./multi-select-group/multi-select/multi-select.component";
import { MultiSelectFormComponent } from "./multi-select-group/multi-select-form/multi-select-form.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { SeatsInputComponent } from "./seats-input/seats-input.component";
import { SelectComponent } from "./select/select.component";
import { SelectWithEnumComponent } from "./select-with-enum/select-with-enum.component";
import { ToggleComponent } from "./toggle/toggle.component";
import { OptionSelectorComponent } from "./option-selector/option-selector.component";


export {
  CalendarComponent,
  CheckboxComponent,
  ColorComponent,
  ConvertibleSeatsInputComponent,
  InputComponent,
  InputPasswordComponent,
  InputSearchComponent,
  MultiselectCheckboxesComponent,
  MultiSelectComponent,
  MultiSelectFormComponent,
  NotificationsComponent,
  SeatsInputComponent,
  SelectComponent,
  SelectWithEnumComponent,
  ToggleComponent,
  OptionSelectorComponent,
};

export const inputs = [
  InputPasswordComponent,
  MultiSelectComponent,
  NotificationsComponent,
  OptionSelectorComponent,
]

export const standaloneInputs = [
  CalendarComponent,
  ColorComponent,
  ConvertibleSeatsInputComponent,
  InputComponent,
  MultiselectCheckboxesComponent,
  MultiSelectFormComponent,
  SeatsInputComponent,
  SelectComponent,
  SelectWithEnumComponent,
  CheckboxComponent,
  InputSearchComponent,
  ToggleComponent,
]
